// extracted by css-extract-rspack-plugin
export default {"icon":"eC0XHj5T6Mc2BzQp"};